import { __assign } from "tslib";
// DS: i3.2
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
var Add = function (props) { return (React.createElement(IconWrap, __assign({}, props),
    React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
        React.createElement("g", null,
            React.createElement("path", { d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z" }))))); };
Add.displayName = 'Add';
export default Add;
//# sourceMappingURL=Add.js.map